module.exports = __webpack_public_path__ + "img/8888.04e757e1.jpg";